<template>
    <tile class="opc-zsched">
      <div v-if="alertMsg">
        <alert class="opc-zsched-top__alert" type="info">
          <span v-html="alertMsg" />
        </alert>
      </div>
      <foldable v-model="isExpanded" :title="title" :isRemoveWrapAriaLabelledby="true">
        <div slot="head" class="opc-zm-base-card__head">
          <div class="opc-zm-base-card__head-left">
            <img class="opc-zm-base-card__logo" :src="logo" :alt="title"/>
          </div>
          <div class="opc-zm-base-card__head-right">
            <h2 class="opc-zm-base-card__name text-capitalize">
              {{ title }}
              <i class="zm-icon-success main-icon" aria-hidden="true"></i>
            </h2>
            <div class="opc-zm-base-card__view-detail-button">
              <zm-button class="opc-zm-base-card__link" type="link" @click="handlePlanDetailsClick" v-if="isExpanded && showPlanDetail">
                {{ $t('billing.plan_details') }}
              </zm-button>
            </div>
            <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
              {{
                $t('billing.zone.desc1', [
                  form.selectedNumber,
                  $money(formPlan ? formPlan.amount : 0),
                  $t(`billing.common.per_billing_cycle_user.${form.billingCycle}`),
                ])
              }}
            </div>
          </div>
        </div>
        <div class="opc-zsched__main">
          <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
            <zm-form-item :label="$t('billing.zone.select_license')">
              <users-alert :maxUsers="maxHost" :selectedUsers="form.selectedNumber" />
              <InputNumberWithPopover
                class="opc-zsched__quantity-selector"
                v-model="form.selectedNumber"
                size="large"
                controls-position="both"
                :min="minHost"
                :max="maxHost"
                @change="submitForm"
                :decrease-tips="decreaseTips"
                :label="title + ' Select the number of users'"
              />
              <bought-license v-if="isEditFlow" :type="planType"/>
              <zm-alert
                class="reason-tips"
                v-if="licenseTips"
                type="info"
                :closable="false"
              >
                <i class="zm-icon-info" style="color: #9191A4;"></i><p v-html="licenseTips"></p>
              </zm-alert>
              <div class="opc-zsched__exceed-assigned-licenses-hint" v-if="mx_downSellLicenseErrorMessage">
                <div class="opc-zsched__exceed-assigned-licenses-hint-icon">
                  <i class="zm-alert__icon zm-icon-warning"></i>
                </div>
                <p class="opc-zsched__exceed-assigned-licenses-hint-text">{{ mx_downSellLicenseErrorMessage }}</p>
              </div>
            </zm-form-item>
            <zm-form-item :label="$t('billing.select_billing_cycle')" id="opc-zsched__billing-cycle">
              <zm-radio-group v-model="form.billingCycle" @change="submitForm" aria-labelledby="opc-zsched__billing-cycle" role="radiogroup" class="opc-card-radio" tabindex="-1">
                <zm-tooltip v-for="plan in currentPlans" :key="plan.billing_cycle" :disabled="!billingCycleDisabled(plan.billing_cycle)" tabindex="-1">
                  <div slot="content" v-html="billingCycleDisabled(plan.billing_cycle) || ''" />
                  <zm-radio
                    tabindex="0"
                    :key="plan.billing_cycle"
                    :label="plan.billing_cycle"
                    :disabled="!!billingCycleDisabled(plan.billing_cycle)"
                    class="opc-zsched__radio"
                  >
                    <p class="opc-zsched__radio-title first-capitalize">
                      <span>{{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}</span>
                      <CycleCurrentBadge :value="plan" />
                      <save-count
                        v-if="plan.cycleValue >= BillingCycleEnum()[BILLING_CYCLE.QUARTERLY]"
                        :disabled="!!billingCycleDisabled(plan.billing_cycle)"
                        :annual-price="(plan.amount / plan.cycleValue) * 12"
                        :monthly-price="cyclePrice.shortestCycleMonthlyPrice"
                      />
                    </p>
                    <p class="opc-zsched__radio-price" tabindex="-1">
                      <!-- <span class="opc-zsched__radio-price-delete" :aria-label="`regular price ${$money(annualPriceM, {forceDiff: true})}`" v-if="plan.billing_cycle === BILLING_CYCLE.ANNUAL">
                        {{ $money(annualPriceM, {forceDiff: true}) }}
                      </span> -->
                      <span>
                        {{ $money(plan.amount, {forceDiff: true}) }}
                      </span>
                      <span class="opc-zsched__radio-price-unit">{{ getPlanUnitWithCycle(plan.billing_cycle) }}<priceVATTip /></span>
                    </p>
                  </zm-radio>
                </zm-tooltip>
              </zm-radio-group>
            </zm-form-item>
          </zm-form>
          <basic-related-tip v-if="isNetNew" />
          <div class="opc-zm-base-card__main__footer" v-if="couldBeRemovedAsAddonCard">
            <zm-button type="link" ghost @click="removePlanByKey" :aria-label="'remove ' + title + ' plan'">{{ $t('billing.common.remove') }}</zm-button>
          </div>
          <preview-payment class="opc-zsched__preview-payment" />
        </div>
      </foldable>
    </tile>
  </template>
  <script>
  import Foldable from '@/components/foldable.vue';
  import Tile from '@/components/tile.vue';
  import baseFormMixin from "@/plans/ZOOM_SCHEDULER/mx/base";
  import formMixin from "@/plans/ZOOM_SCHEDULER/mx/index";
  import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
  import UsersAlert from '../components/alerts.vue';
  import saveMixins from '../../ZOOM_MEETING/save-mixins';
  import { BillingCycleEnum, planTypes } from '@/common/constants';
  import PreviewPayment from '@/views/checkout/payment/preview-payment';
  import Alert from '@/components/zoom-ui-plus/alert/alert.vue';
  import BasicRelatedTip from '../components/basic-related-tip.vue';
  import { $context } from '@/global-install';
  import BoughtLicense from '@/views/config/shopping-cart/prorated/bought-license.vue';
  import CycleCurrentBadge from '@/components/service/config-billing-cycle/cycle-current-badge.vue';

  export default {
    key: planTypes[planTypes.ZOOM_SCHEDULER],
    mounted() {
      this.$context.$on('collapse-plan-card', this.collapseCard);
    },
    methods: {
      BillingCycleEnum() {
        return BillingCycleEnum
      },
      collapseCard() {
        this.isExpanded = false;
      },
    },
    mixins: [baseFormMixin, formMixin, saveMixins],
    components: {
      Alert,
      PreviewPayment,
      Foldable,
      Tile,
      InputNumberWithPopover,
      UsersAlert,
      BasicRelatedTip,
      BoughtLicense,
      CycleCurrentBadge,
    },
    computed: {
      alertMsg() {
        return "";
      },
      isNetNew() {
        return $context.is.buyNow || $context.is.buyTrial || $context.is.basic2pro;
      },
      isEditFlow() {
        return $context.is.edit;
      },
    },
  };
  </script>

  <style lang="scss">
  @import '@/styles/_variables.scss';
  @import '@/styles/zoom-card.scss';
  @import '@/styles/scss-utils.scss';

  .opc-zsched {
    .opc-zsched-top__alert {
      display: flex;
      padding: 16px;
      align-items: center;
      gap: 16px;
      border-radius: 8px;
      background: #F7F7F8;
      margin-bottom: 24px;

      .zm-alert__icon {
        margin-right: 0;
      }

      .zm-alert__body {
        padding: 0;
        color: #666487;
        font-size: 14px;
        font-style: normal;
        font-weight: 450;
        line-height: 150%;
      }
    }
    .main-icon {
      color: $theme-color;
    }
    &__link.zm-button--link {
      font-weight: 700 !important;
      color: $theme-color;
      padding: 0;
    }
    &__quantity-selector {
      margin-top: 12px;
    }
    &__main {
      margin-top: 24px;
      padding-top: 24px;
      border-top: 1px solid #dfdfe4;
      @include darkTheme() {
        border-color: $dark-border-color;
      }
    }
    &__desc {
      position: relative;
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #515079;
      padding: 0;
      &.is-warning {
        padding: 8px 12px 8px 48px;
        background: #FEF7D9;
        border-radius: 8px;
        &::before {
          content: '';
          background-image: url('../../../assets/Alert.svg');
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: cover;
          position: absolute;
          top: 10px;
          left: 20px;
        }
      }
    }
    &__exceed-assigned-licenses-hint {
      margin-top: 12px;
      display: flex;
      padding: 8px 17px;
      align-items: center;
      background: #F2F2F4;
      border-radius: 8px;
      &-icon {
        color: #9191A4;
        width: 14px;
      }
      &-text {
        margin-left: 13px;
        font-size: 14px;
        line-height: 1.5;
        color: #515079;
      }

    }
    .opc-card-radio {
      margin-top: 8px;

      .opc-zsched__radio {
        width: 100%;
        .zm-radio__wrap {
          width: 100%;
        }
      }
    }
    .opc-card-radio &__radio {
      .zm-radio__label--inner {
        width: 100%;
        min-height: 90px;
        padding: 16px;
      }
      &-title {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 150%;
        color: #00053d;
        margin: 0;
        @include darkTextColor;
        display: flex;
        align-items: center;
      }
      &-price {
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 33px;
        color: #00053d;
        @include darkTextColor;
        &-unit {
          font-weight: 450;
          font-size: 12px;
          line-height: 16px;
          @include darkTextColor2;
        }
        &-delete {
          font-weight: 450;
          font-size: 14px;
          line-height: 150%;
          text-decoration-line: line-through;
          color: #515079;
        }
      }
    }

    &__preview-payment {
      margin-top: 24px;
    }

  }
  .reason-tips {
    margin-top: 12px;

    .zm-alert__description {
      display: flex;
      align-items: center;
    }

    p {
      margin-left: 13px;
      font-family: 'Almaden Sans';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #515079;
    }
  }
  </style>
